"use client";
import cn from "classnames";
import { useCallback, useState } from "react";
import { type WistiaOptions } from "@/components/common/VideoService/services/WistiaVideo";
import { useAutoplayVideoInViewport } from "@/hooks/useAutoplayVideoInViewport";
import VideoService, { type VideoServiceProps } from "../VideoService";
import s from "./BackgroundVideo.module.scss";

export type BackgroundVideoProps = Pick<
  VideoServiceProps,
  "source" | "videoId"
>;

const wistiaOptions: WistiaOptions = {
  bigPlayButton: false,
  controlsVisibleOnLoad: false,
  endVideoBehavior: "loop",
  fitStrategy: "cover",
  muted: true,
  silentAutoplay: "allow",
  transparentLetterbox: true,
  style: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};

export default function BackgroundVideo(props: BackgroundVideoProps) {
  const { source, videoId } = props;

  const [fadeIn, setFadeIn] = useState(false);
  const videoRef = useAutoplayVideoInViewport();

  const handleStartPlaying = useCallback(() => {
    if (!fadeIn) {
      setFadeIn(true);
    }
  }, [fadeIn]);

  if (!videoId) return null;

  const className = cn(s.wrapper, {
    [s.fadeIn]: fadeIn,
  });

  return (
    <div className={className}>
      <VideoService
        ref={videoRef}
        source={source}
        videoId={videoId}
        controls={false}
        muted
        loop
        wistiaOptions={wistiaOptions}
        onPlay={handleStartPlaying}
      />
      <div className={s.overlay} />
    </div>
  );
}
